import { LocalAudioTrack, LocalDataTrack, LocalVideoTrack } from 'twilio-video';

interface EnsureLocalMediaTracksArgs {
  localTracks: (LocalAudioTrack | LocalDataTrack | LocalVideoTrack)[];
  getLocalAudioTrack: (deviceId?: string) => Promise<LocalAudioTrack>;
  getLocalVideoTrack: () => Promise<LocalVideoTrack>;
}

export const ensureLocalMediaTracks = async ({
  localTracks,
  getLocalAudioTrack,
  getLocalVideoTrack,
}: EnsureLocalMediaTracksArgs) => {
  const createMissingTracks: Promise<LocalAudioTrack | LocalVideoTrack>[] = [];

  if (!localTracks.some(track => track.kind === 'audio')) {
    createMissingTracks.push(getLocalAudioTrack());
  }

  if (!localTracks.some(track => track.kind === 'video')) {
    createMissingTracks.push(getLocalVideoTrack());
  }

  return Promise.all(createMissingTracks);
};
